import { render, staticRenderFns } from "./WorkspaceDocuments.vue?vue&type=template&id=e87a9e7e&"
import script from "./WorkspaceDocuments.vue?vue&type=script&lang=js&"
export * from "./WorkspaceDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports